import React from "react";
import {withTranslation} from "react-i18next";
import {Image, Page, Text, View} from "@react-pdf/renderer";

function PiePdf(props) {

    const {t, styles,stylesPdf} = props;

    return (
        <Page size="A4" style={stylesPdf.page}>
            <Image src="/assets/img/backgroundpdf.png" style={stylesPdf.pageBackground} fixed/>
            <View style={stylesPdf.rowheader}>
                <View style={{flexDirection: "row"}}>
                    <View style={{
                        width: "190px",
                        textAlign: "left",
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: 24
                    }}>
                        <Image style={styles.imagelogoheader} src="/assets/img/logoblanco.png"/>
                    </View>
                </View>
            </View>
            <View style={{display: "flex", flexDirection: "column", alignItems: "center", margin: "auto"}}>
                <Image style={stylesPdf.imageLogoCenter} src="/assets/img/logo.png"/>
            </View>
            <View fixed style={stylesPdf.footerFirstPage}>
                <Text>{t("contrato.footer")}</Text><Text>{t("contrato.subfooter")}</Text>
            </View>
            <Image src="/assets/img/wave-yellow-informes.png" style={stylesPdf.pageBackgroundFooter} fixed/>
        </Page>
    )}

export default withTranslation()(PiePdf);
